import React, { useState, useEffect, useRef } from "react";
import api from "../Api";
import "../Styles/Home.css";
import "../Styles/Typemsg.css";
import { useNavigate } from "react-router-dom";

function Typemsg() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [chat, setChat] = useState([]);
  const [loading, setLoading] = useState(false);
  const chatEndRef = useRef(null);

  // Auto scroll to bottom
  // useEffect(() => {
  //   chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  // }, [chat, loading]);

useEffect(() => {
  const fetchmessage = async () => {
    try {
      const res = await api.get("/messages", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      if (res?.data?.status && Array.isArray(res.data.data)) {
        const formattedMessages = res.data.data.flatMap(item =>
          item.comments.map(c => ({
            from: c.type === "User" ? "user" : "bot",
            text: c.comment,
          }))
        );

        setChat(
          formattedMessages.length
            ? formattedMessages
            : [{ from: "bot", text: "Hello! How can we assist you with your travel plans today?" }]
        );
      } else {
        setChat([
          { from: "bot", text: "Hello! How can we assist you with your travel plans today?" }
        ]);
      }
    } catch (error) {
      console.error(error);
      setChat([
        { from: "bot", text: "Hello! How can we assist you with your travel plans today?" }
      ]);
    }
  };

  fetchmessage();
}, []);


  const sendMessage = async () => {
    if (!message.trim()) return;

    const userMsg = message;
    const token = localStorage.getItem("accessToken");
    if (!token) {
      alert("Please log in to send messages.");
      navigate("/signup");
      return;
    }
    setChat((prev) => [...prev, { from: "user", text: userMsg }]);
    setMessage("");
    setLoading(true);

    try {
      const res = await api.post(
        "/messages",
        { message: userMsg },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      if (res?.data?.status) {
        setChat((prev) => [
          ...prev,
          { from: "bot", text: "✅ Thanks! Our team will contact you via Email soon." },
        ]);

        // alert("Your message has been sent successfully.");
      }
    } catch {
      setChat((prev) => [
        ...prev,
        { from: "bot", text: "Something went wrong 😕" },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
<div className="tm-contact">
 

  <div className="tm-message-box">
     <h1 className="tm-title">Get exclusive travel tips and deals in your inbox</h1>
    {/* Chat Area */}
    <div className="tm-chat-area">
      {chat.map((msg, i) => (
        <div key={i} className={`tm-chat-bubble tm-${msg.from}`}>
          {msg.text}
        </div>
      ))}

      {loading && <div className="tm-chat-bubble tm-bot">Typing...</div>}
      <div ref={chatEndRef} />
    </div>

    {/* Input Area */}
    <div className="tm-input-area">
      <textarea
        className="tm-textarea"
        placeholder="Type your message..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            sendMessage();
          }
        }}
      />
      <button className="tm-send-btn" onClick={sendMessage}>➜</button>
    </div>
  </div>
</div>

  );
}

export default Typemsg;
